import { withInstall } from '@zoryn/utils'
import DatePicker from './src/date-picker'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDatePicker: SFCWithInstall<typeof DatePicker> =
  withInstall(DatePicker)

export default ZDatePicker
export * from './src/props'
export type { DatePickerInstance } from './src/instance'
